import React, {Component} from 'react';
import {Row} from 'antd';
import WrappedNormalLoginForm from './login';
import {getCsrfToken} from "../redux_actions/login.action";
import {connect} from "react-redux";
import cookie from "react-cookies";

class LoginView extends Component {
    constructor(props) {
		super(props);
        this.props.dispatch(getCsrfToken());
	}

    render() {

        let search = ((this.props.location.state || {}).from || {}).search;
        let demoLogin = false;
        if (search) {
            demoLogin = search.includes("demo=true");
        }

        let displayMessage = cookie.load("display_message");
        let resolution = cookie.load("resolution");

        return (
            <Row className="login-mp">
                <WrappedNormalLoginForm demoLogin={demoLogin} message={displayMessage} resolution={resolution}/>
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return state.loginAlerts;
}

export default connect(mapStateToProps)(LoginView);
